module.exports = __webpack_public_path__ + "static/media/modelo_1.6ed2f5ac.svg";